import { items } from '../../shared/Items'
import { EQUIP_SLOTS } from '../../shared/inventories'
import { ClientEntity } from './ClientEntity'

export class ClientHarvestNode extends ClientEntity {
  static type = 'harvest_node'

  getTargetInfo() {
    return this.data.target
  }

  getInteractInfo() {
    if (this.data.harvest?.depleted) return null
    const interact = this.data.interact
    if (!interact) return null
    if (interact.tool) {
      const slot = this.world.inventory.data?.slots[EQUIP_SLOTS.rItem]
      const item = items[slot?.id]
      if (!item?.tool || item.tool.type !== interact.tool) return null
      if (interact.tier && item.tool.tier < interact.tier) return null
    }
    return interact
  }

  canInteract() {
    return true
  }

  isHitBy(item) {
    const melee = this.data.harvest?.melee
    if (!melee) return false
    if (this.data.harvest.depleted) return false
    if (item?.consumable) return false
    if (item?.use?.kind && item.use.kind !== 'melee') return false
    if (melee.tool) {
      if (!item?.tool) return false
      if (item.tool.type !== melee.tool) return false
      if (item.tool.tier < melee.tier) return false
    }
    return true
  }

  init() {
    const depleted = this.data.harvest?.depleted
    const spriteUrl = depleted ? this.data.harvest.depletedSprite : this.data.sprite.url
    const shadowUrl = depleted ? this.data.harvest.depletedShadow : this.data.shadow?.url
    if (spriteUrl) {
      this._sprite = this.world.sprites.add({
        x: this.data.position.x,
        y: this.data.position.y,
        yBase: this.data.position.yBase,
        ySort: this.data.sprite.ySort,
        url: spriteUrl,
        width: this.data.sprite.width,
        height: this.data.sprite.height,
        fps: this.data.sprite.fps,
      })
    }
    if (shadowUrl) {
      this._shadow = this.world.shadows.add({
        x: this.data.position.x,
        y: this.data.position.y,
        url: shadowUrl,
        width: this.data.sprite.width,
        height: this.data.sprite.height,
      })
    }
    const hasCollider = this.data.collider && !(depleted && 'depletedCollider' in this.data.harvest)
    if (hasCollider) {
      const c = this.data.collider
      this._collider = this.world.physics.add(
        this.data.position.x,
        this.data.position.y,
        { type: 'solid', ox: c.ox, oy: c.oy, w: c.w, h: c.h },
        this
      )
    }
    this._action = this.world.targets.add({
      px: this.data.position.x,
      py: this.data.position.y,
      ox: this.data.target?.ox,
      oy: this.data.target?.oy,
      radius: this.data.target?.radius || 0,
      value: this,
    })
  }

  onChange(changes) {
    if (changes.position) {
      this._sprite?.setPosition(this.data.position.x, this.data.position.y)
      this._collider?.setPosition(this.data.position.x, this.data.position.y)
      this._action?.setPosition(this.data.position.x, this.data.position.y)
    }
    if (changes.harvest && 'depleted' in changes.harvest) {
      const depleted = this.data.harvest.depleted
      const spriteUrl = depleted ? this.data.harvest.depletedSprite : this.data.sprite.url
      const shadowUrl = depleted ? this.data.harvest.depletedShadow : this.data.shadow?.url
      this._sprite?.destroy()
      this._sprite = null
      if (spriteUrl) {
        this._sprite = this.world.sprites.add({
          x: this.data.position.x,
          y: this.data.position.y,
          yBase: this.data.position.yBase,
          ySort: this.data.sprite.ySort,
          url: spriteUrl,
          width: this.data.sprite.width,
          height: this.data.sprite.height,
          fps: this.data.sprite.fps,
        })
      }
      this._shadow?.destroy()
      this._shadow = null
      if (shadowUrl) {
        this._shadow = this.world.shadows.add({
          x: this.data.position.x,
          y: this.data.position.y,
          url: shadowUrl,
          width: this.data.sprite.width,
          height: this.data.sprite.height,
        })
      }
      if ('depletedCollider' in this.data.harvest) {
        if (depleted) {
          this._collider?.destroy()
          this._collider = null
        } else if (this.data.collider) {
          const c = this.data.collider
          this._collider = this.world.physics.add(
            this.data.position.x,
            this.data.position.y,
            { type: 'solid', ox: c.ox, oy: c.oy, w: c.w, h: c.h },
            this
          )
        }
      }
    }
  }

  wobble() {
    this._sprite?.wobble()
  }

  destroy() {
    this._action?.destroy()
    this._collider?.destroy()
    this._sprite?.destroy()
    this._shadow?.destroy()
    super.destroy()
  }
}
